import { ErrorMessage } from "@hookform/error-message";
import React from "react";
import { Form } from "react-bootstrap";
import { Controller } from "react-hook-form";

const TextField = ({
  errors,
  placeholder,
  multiErrorFields,
  disabled,
  type,
  textarea,
  name,
  autoFocus,
  handleFocus,
  handleBlur,
  maxLength,
  minLength,
  onKeyDown,
  formMethod,
  rows,
  defaultValue,
  rules,
  errorIcon,
  successIcon,
  readOnly,
  required,
  min,
  max,
  onClick,
  ref,
  textCountVisible,
  textcount,
  textCountTotal,
  onChange,
  onWheel,
  autoCapitalize,
  /** When false, password and other fields keep leading spaces as typed. */
  stripLeadingWhitespace = true,
}) => {
  const hasError = errors[name] !== undefined;

  return (
    <>
      <Controller
        defaultValue={defaultValue}
        render={({ field: { onChange: controllerOnChange, value } }) => (
          <>
            <Form.Control
              className={`${hasError ? "is-invalid" : ""} ${
                value &&
                rules.pattern &&
                rules.pattern.value &&
                rules.pattern.value.test(value)
                  ? "regex-match-class"
                  : ""
              }`}
              name={name}
              ref={ref}
              placeholder={placeholder}
              autoFocus={autoFocus}
              disabled={disabled}
              autoComplete="off"
              required={required}
              type={type}
              as={textarea}
              readOnly={readOnly}
              rows={rows}
              onBlur={handleBlur}
              onKeyDown={onKeyDown}
              maxLength={maxLength}
              minLength={minLength}
              min={min}
              max={max}
              onWheel={onWheel}
              onFocus={(e) => {
                handleFocus && handleFocus(e);
              }}
              defaultValue={defaultValue}
              onChange={(e) => {
                const next = stripLeadingWhitespace
                  ? e.target.value.trimStart()
                  : e.target.value;
                controllerOnChange && controllerOnChange(next);
                onChange && onChange(e);
              }}
              onClick={onClick}
              value={formMethod.watch(name) || value ? value : ""}
              autoCapitalize={autoCapitalize}
            />
          </>
        )}
        name={name}
        control={formMethod?.control}
        rules={rules}
      />
      {multiErrorFields?.length > 0 ? (
        <ErrorMessage
          errors={errors}
          name={name}
          render={({ messages }) => {
            if (messages) {
              const isMultipleError = Object.keys(messages).every(
                (errKey) =>
                  multiErrorFields.filter((m) => m[errKey] !== undefined)
                    .length > 0
              );
              if (isMultipleError) {
                const arr = [];
                for (const fieldError of multiErrorFields) {
                  const key = Object.keys(fieldError)[0];
                  const success = Object.keys(messages).includes(key);
                  arr.push(
                    <div className={success ? "red" : "green"} key={key}>
                      <span key={key}>
                        <i className={success ? errorIcon : successIcon} />
                        {fieldError[key]}
                      </span>
                    </div>
                  );
                }
                return (
                  <div className="errorMsg 2 show passwordcustom">{arr}</div>
                );
              } else {
                return (
                  <div className="errorMsg 1 show">
                    <i className={errorIcon} />
                    {errors[name]?.message}
                  </div>
                );
              }
            } else {
              return <div className="errorMsg 3"></div>;
            }
          }}
        />
      ) : hasError ? (
        <div className="errorMsg 4 show">
          <span>
            <i className={errorIcon} />
            {errors[name]?.message}
          </span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

TextField.defaultProps = {
  autoFocus: false,
  value: "",
  errors: {},
  multiErrorFields: [],
  noNegative: false,
  errorIcon: "icon-error_outline",
  successIcon: "icon-checkmark",
  readOnly: false,
  required: true,
  noTextfield: false,
};

export default TextField;
